export default __webpack_public_path__ + "static/media/librato.f815bbb5.svg";